(function () {
  var CLS = "HFB-079-AB--var-1";

  function shield() {
    return (window.HFB079 && window.HFB079.shield) || "";
  }

  function cardMarkup() {
    return (
      '<div class="hfb-079">' +
      '<img class="hfb-079__icon" src="' + shield() + '" alt="" width="24" height="24">' +
      '<div class="hfb-079__copy">' +
      '<p class="hfb-079__title">30 days to try it</p>' +
      '<p class="hfb-079__text">Not for you? Full refund, no questions asked.</p>' +
      "</div></div>"
    );
  }

  function buyHost() {
    var root = document.querySelector("#product-main") || document;
    var button = root.querySelector(".buy-button .product-main-add");
    if (!button) return null;
    if (button.closest("#stickyAtcBar, .sticky-atc-bar")) return null;
    return button.closest(".buy-button");
  }

  function place() {
    if (!document.documentElement.classList.contains(CLS)) return;
    var host = buyHost();
    if (!host || !host.parentNode) return;

    var card = document.querySelector("#product-main .hfb-079, .product-main-form .hfb-079");
    if (!card) {
      host.insertAdjacentHTML("afterend", cardMarkup());
      card = host.nextElementSibling;
    } else if (card.previousElementSibling !== host) {
      host.after(card);
    }
  }

  function watch() {
    place();
    var obs = new MutationObserver(place);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    if (document.body) obs.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(place, 400);
    window.setTimeout(place, 1200);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
